// extracted by mini-css-extract-plugin
export var firstFlag = "flagButtons-module--firstFlag--38120";
export var flag = "flagButtons-module--flag--4e65c";
export var flags = "flagButtons-module--flags--7b751";
export var hidden = "flagButtons-module--hidden--55053";
export var showSelectedLangOnly = "flagButtons-module--showSelectedLangOnly--a4320";